import { meetingConstants, userConstants } from '../constants';

const { MEETING_TEMPLATE_TYPES } = meetingConstants;
const { SUB_ROLES } = userConstants;

const API_MEETING_TYPE_TO_TEMPLATE = {
  'annual general meeting': MEETING_TEMPLATE_TYPES.ANNUAL_GENERAL_MEETING,
  'general meeting': MEETING_TEMPLATE_TYPES.GENERAL_MEETING,
  'committee meeting': MEETING_TEMPLATE_TYPES.COMMITTEE_MEETING,
};

export const getMeetingTemplateType = meeting => {
  const raw = (meeting?.meeting_type || '').toLowerCase().trim();
  return raw ? API_MEETING_TYPE_TO_TEMPLATE[raw] ?? null : null;
};

const isOwnerRole = user => {
  const role = user?.role;
  const subroles = user?.subroles || [];
  return (
    role === SUB_ROLES.OWNER_OCCUPIER ||
    role === SUB_ROLES.OWNER_LANDLORD ||
    subroles.some(s => s?.role === SUB_ROLES.OWNER_OCCUPIER || s?.role === SUB_ROLES.OWNER_LANDLORD)
  );
};

const isCommitteeMemberRole = user => {
  const role = user?.role;
  const subroles = user?.subroles || [];
  return role === SUB_ROLES.COMMITTEE_MEMBER || subroles.some(s => s?.role === SUB_ROLES.COMMITTEE_MEMBER);
};

export const hasVoteAccessForMeeting = (user, meeting) => {
  const completedStates = ['completed', 'closed', 'incomplete'];
  if (completedStates.includes(meeting?.state)) return false;

  const templateType = getMeetingTemplateType(meeting);
  const isOwner = isOwnerRole(user);
  const isCommittee = isCommitteeMemberRole(user);
  const isCommitteeAndOwner = isCommittee && isOwner;

  // Committee members who are also owners can vote in all meeting types (AGM, General, Committee)
  if (isCommitteeAndOwner) return true;

  if (!templateType) return false;

  if (isOwner && !isCommittee) {
    return templateType === MEETING_TEMPLATE_TYPES.ANNUAL_GENERAL_MEETING || templateType === MEETING_TEMPLATE_TYPES.GENERAL_MEETING;
  }

  if (isCommittee && !isOwner) {
    return templateType === MEETING_TEMPLATE_TYPES.COMMITTEE_MEETING;
  }

  return false;
};

export const transformInternalMeeting = meeting => {
  let meetingDate = null;

  if (meeting.time_from) {
    if (typeof meeting.time_from === 'number') {
      meetingDate = meeting.time_from;
    } else if (typeof meeting.time_from === 'string') {
      meetingDate = Math.floor(new Date(meeting.time_from).getTime() / 1000);
    }
  } else if (meeting.date) {
    const dateTimeString = meeting.date;
    meetingDate = Math.floor(new Date(dateTimeString).getTime() / 1000);
  }

  return {
    id: meeting.id,
    meeting_id: meeting.id,
    meeting_date: meetingDate,
    state: meeting.status === 'upcoming' ? 'upcoming' : meeting.status || 'non-votable',
    can_vote: false,
    voted: false,
    internal: true,
    meeting_type: meeting.template_name || 'Meeting',
    meeting_venue: meeting.venue || 'TBD',
  };
};
